import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ManageWebsites from "./routes/ManageWebsites";
import CourseMapFeed from "./routes/CourseMapFeed";
import MapFeed from "./routes/MapFeed";

export default store => ({
  path: "curriculum-publishing",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "curriculum-maps" */ "./components"),
      import(
        /* webpackChunkName: "curriculum-maps" */ "./modules/CurriculumMapsModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;

      const reducer = importedModule1.default;

      injectReducer(store, {
        key: "curriculumMaps",
        reducer,
      });
      return component;
    })
  ),
  childRoutes: [ManageWebsites(store), CourseMapFeed(store), MapFeed(store)],
});
